import { RouteConfig } from 'vue-router'

import {
	Login
} from '@/views'

const routesAuth: Array<RouteConfig> = [
	{
		path: 'login',
		component: Login,
		name: 'login',
		meta: {
			requiresVisitor: true,
			requiresAuth: false,
			title: 'Login'
		}
	}
]

export default routesAuth
